var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('PublicHeader',{attrs:{"totalName":_vm.$t('common').Activecenter}}),_c('img',{staticClass:"topimg",attrs:{"src":require("@/assets/img/activity_recharge.png")}}),_c('div',{staticClass:"content ql-editor",domProps:{"innerHTML":_vm._s(_vm.$t('activity').rechargeRewardTxt)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }